import React, { useEffect } from 'react';

import './Profile.scss';
import { Button, Form, Input, Select } from 'antd';
import { useDispatch } from 'react-redux';
import { ReactSVG } from 'react-svg';

import { doUpdateUser } from '../../../modules/users/store/thunk';
import { ROLES } from '../../../constants';
import { useSelector } from 'react-redux';
import { doGetImpersonables, doGetProfile, doImpersonateUser } from '../../../modules/auth/stores/thunk';

const UserProfile = ({ user }) => {
  const dispatch = useDispatch();
  const [formUser] = Form.useForm();
  const [impersonateForm] = Form.useForm();

  const impersonables = useSelector((state) => state.auth.impersonables);

  const role = useSelector((state) => state.auth.user.role);

  useEffect(() => {
    if (user) {
      const initialValues = {
        name: user.name,
        email: user.email,
      };
      formUser.setFieldsValue(initialValues);
    } else {
      formUser.resetFields();
    }
  }, [user]);

  useEffect(() => {
    if (role === ROLES.ADMIN) {
      dispatch(doGetImpersonables());
    }
  }, [role]);

  const onSubmitUser = async (values) => {
    try {
      const params = {
        id: user.id,
        name: values.name,
        email: values.email,
      };
      await dispatch(doUpdateUser(params));
    } catch (e) {
      console.log(e);
    }
  };

  const onSubmitImpersonate = async (v) => {
    const params = { id: v.user };
    await dispatch(doImpersonateUser(params));
    await dispatch(doGetProfile());
    window.location.reload();
  };

  const onOkUser = () => {
    formUser.submit();
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'left' }}>
        <div className="profile">
          <div className="profile-content">
            <h3>User Profile</h3>
            <h5>Your profile information</h5>
          </div>
          <div className="UserForm">
            <Form form={formUser} onFinish={onSubmitUser} layout="vertical" scrollToFirstError className="FormContent">
              <Form.Item label="Name" name="name" initialValue={user.name}>
                <Input size="large" />
              </Form.Item>
              <Form.Item label="Email Address" name="email" initialValue={user.email}>
                <Input size="large" />
              </Form.Item>
            </Form>
            <div className="FormFooter">
              <Button
                className="CreateButton ButtonPrimary"
                type="primary"
                style={{ marginLeft: 'auto' }}
                onClick={onOkUser}
              >
                Update
                <ReactSVG className="icon" src="/icons/done.svg" />
              </Button>
            </div>
          </div>
        </div>
        {role === ROLES.ADMIN && (
          <div className="profile">
            <div className="profile-content">
              <h3>Impersonate another account</h3>
              <h5>As an admin you can use the sparqle frontend as if you were logged in as a carrier or provider</h5>
            </div>
            <div className="UserForm">
              <Form
                form={impersonateForm}
                onFinish={onSubmitImpersonate}
                layout="vertical"
                scrollToFirstError
                className="FormContent"
              >
                <Form.Item label="User to impersonate" name="user">
                  <Select
                    placeholder="Select a user"
                    optionFilterProp="label"
                    options={impersonables?.map((u) => ({
                      value: u.id,
                      label: u.email,
                    }))}
                    showSearch
                  />
                </Form.Item>

                <div className="FormFooter">
                  <Button
                    className="CreateButton ButtonPrimary"
                    type="primary"
                    style={{ marginLeft: 'auto' }}
                    htmlType="submit"
                  >
                    Impersonate this user
                    <ReactSVG className="icon" src="/icons/done.svg" />
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        )}
      </div>
      <div className="profile">
        <div className="profile-content">
          <h3>Need help?</h3>
          <h5>
            We have created a user guide that covers how to use the Sparqle dashboard{' '}
            <a
              href="https://support.sparqle.com/nl/articles/10057143-sparqle-gebruikershandleiding"
              target="_blank"
              rel="noopener noreferrer"
            >
              <b>here.</b>
            </a>
          </h5>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
